// Barrel do slice de mutations do modulo de tarefas.
//
// `store/index.js` faz `import * as m from './mutations'` e espalha o
// resultado em `mutations`, entao TUDO que sai daqui vira uma mutation Vuex.
// Por isso o barrel reexporta apenas os dois modulos publicos — o helper
// privado fica em `mutations-internal.js`, que NAO e reexportado.
export * from './mutations-tasks'
export * from './mutations-slices'
